module.exports = __webpack_public_path__ + "img/banner.e24a991e.png";